import { render, staticRenderFns } from "./tenant-roster.vue?vue&type=template&id=0bca009d"
import script from "./tenant-roster.vue?vue&type=script&lang=js"
export * from "./tenant-roster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports